import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {
    CompanyVettingContactModel,
    SaveCompanyVettingContactResponse,
    CompanyCertificateModel,
    GetCompanyResponseModel,
    CompanySubscoreDetails,
    GetGhgPerformanceRequest,
    SubmitManagementAuditRequest,
    GetCompanyListFlagsResponse,
} from "../../models/companies/company.models";
import {Urls} from "../../constants/modules/company.constants";
import { GetBannerResponse, GetDocPerformance, GetCompanyPerformanceDemography, GetGhgPerformance } from "../../models/vessels/vessel.models";
import { RequestConstants } from "@rightship-tech/common-ui/constants/request.constants";
import { FileHelper } from "../../helpers/file-helper";
import { ConfigurationService } from "@rightship-tech/common-ui/services/basic/configuration.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject()
export class CompanyService {

    constructor(private requestClient: RequestClientService, private configurationService: ConfigurationService, private configService : ConfigService) { }


    public getDocFleet(request): Promise<any[]> {
        return this.requestClient.post(Urls.GetDocFleet, {}, request);
    }

    public downloadDocFleet(r) {
        return new Promise<void>((resolve, reject) => {
            try {
                const url = this.configService.config.urls.rightShipPlatformApiUrl + `/api/v1/Company/Download`;
                $.ajax({
                    type: "POST",
                    contentType: "application/json",
                    data: JSON.stringify(r),
                    url: url,
                    xhrFields: {
                        withCredentials: true
                    },
                    beforeSend: (request) => {
                        const headers = this.configurationService.getList(RequestConstants.ConfigurationTypes.RequestHeaders);
                        const keys = Object.keys(headers);
                        keys.forEach(key => {
                            request.setRequestHeader(key, headers[key]?.toString());
                        });
                    },
                    success: x => {
                        const url = window.URL.createObjectURL(x);
                        FileHelper.downloadFile(url, 'DOC Fleet.xlsx');

                        setTimeout(() => {
                            window.URL.revokeObjectURL(url);
                            resolve();
                        });
                    },
                    error: () => {
                        reject();
                    },
                    xhr: () => {
                        const xhr = new XMLHttpRequest();
                        xhr.responseType = 'blob'
                        return xhr;
                    }
                });
            }
            catch (exception) {
                resolve();
            }
        });
    }


    public getCompany(id: number): Promise<GetCompanyResponseModel> {
        return this.requestClient.get<GetCompanyResponseModel>(Urls.GetCompany, { companyId: id })
    }

    public getCompanySubscoreDetail(id: number): Promise<CompanySubscoreDetails> {
        return this.requestClient.get<CompanySubscoreDetails>(Urls.GetCompanySubscoreDetails, { companyId: id })
    }

    public getCompanyListFlags(id: number): Promise<GetCompanyListFlagsResponse> {
        return this.requestClient.get<GetCompanyListFlagsResponse>(Urls.GetCompanyListFlags, { companyId: id })
    }

    public getCompanyBanners(companyId: number): Promise<GetBannerResponse[]> {
        return this.requestClient.get(`${Urls.GetBanners}/${companyId}`, {});
    }

    public getCompanyCertificates(companyId: number): Promise<CompanyCertificateModel[]> {
        return this.requestClient.get(`${Urls.GetCompanyCertificates}/${companyId}`, {});
    }

    public getDocPerformance(companyId: number): Promise<GetDocPerformance> {
        return this.requestClient.get(`${Urls.GetDocPerformance}/${companyId}`, {});
    }

    public getGhgPerformance(request: GetGhgPerformanceRequest): Promise<GetGhgPerformance> {
        return this.requestClient.post(`${Urls.GetGhgPerformance}`, {}, request);
    }

    public GetCompanyPerformanceDemography(companyId: number): Promise<GetCompanyPerformanceDemography> {
        return this.requestClient.get(`${Urls.GetCompanyPerformanceDemography}/${companyId}`, {});
    }

    public getCompanyVettingContact(id: number): Promise<CompanyVettingContactModel> {
        return new Promise<CompanyVettingContactModel>((resolve, reject) => {
            this.requestClient.get<{vettingContact:CompanyVettingContactModel}>(Urls.GetCompanyVettingContact, { companyVettingContactId: id },)
                .then((response) => {
                    resolve(response.vettingContact);
                }, e => {
                    reject(e);
                });
        });
    }

    public removeCompanyVettingContact(id: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.requestClient.get<{removed:boolean}>(Urls.RemoveCompanyVettingContact, { companyVettingContactId: id })
                .then((response) => {
                    resolve(response && response.removed ? response.removed : false);
                }, e => {
                    reject(e);
                });
        });
    }

    public saveCompanyVettingContact(request: CompanyVettingContactModel): Promise<SaveCompanyVettingContactResponse> {
        return this.requestClient.post(Urls.SaveCompanyVettingContact, {}, request);
    }

    public submitManagementAudit(request: SubmitManagementAuditRequest): Promise<boolean> {
        return this.requestClient.post(Urls.SubmitManagementAudit, {}, request);
    }

    public getMaskDataForCompany(companyId: number): Promise<boolean> {
        return this.requestClient.get(`${Urls.GetMaskDataForCompany}/${companyId}`, {});
    }
}